import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { TranslateModule } from '@ngx-translate/core';
import { NgxLoadingModule } from 'ngx-loading';
// import { MatButtonModule, MatCheckboxModule, MatIconModule } from '@angular/material';
import { FuseSharedModule } from '@fuse/shared.module';
import { ClientesService } from './clientes.service';
import { ClientesComponent, DialogDataExampleDialogComponent } from './clientes.component';
import {HttpClientModule} from '@angular/common/http';
import {HttpModule} from '@angular/http';
import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { MatButtonModule, MatDatepickerModule, MatFormFieldModule, MatSelectModule, MatCheckboxModule, MatIconModule, MatInputModule, MatSlideToggleModule, MatToolbarModule } from '@angular/material';
import { FuseConfirmDialogModule } from '@fuse/components';
import {Anadirpagocomponent2Component} from '../anadirpagocomponent2/anadirpagocomponent2.component'
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
const routes = [
    {
        path     : 'clientes',
        component: ClientesComponent
    }
];

@NgModule({
    declarations: [
        ClientesComponent,
        DialogDataExampleDialogComponent,
        Anadirpagocomponent2Component
    ],
    imports     : [
        RouterModule.forChild(routes),
        MatButtonModule,
        MatCheckboxModule,
        SweetAlert2Module,
        NgxLoadingModule,
        MatIconModule,
        TranslateModule,
        AgGridModule.withComponents([]),
        FuseSharedModule,
        HttpClientModule, HttpModule,
        FuseConfirmDialogModule,
        MatDatepickerModule,
        
        NgxMatSelectSearchModule,
        MatSelectModule,
    MatToolbarModule,
    MatFormFieldModule,
    MatInputModule
    
    ],
    exports     : [
        ClientesComponent
    ],
    providers: [ClientesService],
    entryComponents: [Anadirpagocomponent2Component, DialogDataExampleDialogComponent],

 
})

export class ClientesModule
{
}
